export default __webpack_public_path__ + "static/media/Resume.d7e3a45d.pages";